<template>
    <div style="display: flex">
        <div style="width: 20%; border: 1px solid #dcdee2; margin-top: 1vw; margin-left: 1vw; border-radius: 8px">
            <el-tree :data="faultData" :props="defaultProps" node-key="faultId" :default-expanded-keys="faultIdList" @node-click="treeNodeSelect"> </el-tree>
        </div>
        <div class="tableOrgBox">
            <LabelContent title="故障代码" ref="LabelContent">
                <div slot="btns">
                    <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                    <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                    <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                    <el-button size="small" type="success" @click=";(faultCodeAdd = true), updateFaultCode()" v-for="acc in access" v-if="acc == 'FAULTCODEADD001'"> 新增 </el-button>
                </div>
            </LabelContent>
            <el-table stripe ref="multipleTable" :data="faultCodeList" class="center">
                <el-table-column prop="systemCode" sortable label="故障编号" show-overflow-tooltip />
                <el-table-column prop="faultName" sortable label="故障名称" show-overflow-tooltip />
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <i class="editBtn iconfont u-youjianbianji" @click=";(faultCodeAdd = false), updateFaultCode(scope.row)" v-for="acc in access" v-if="acc == 'FAULTCODEEDIT001'" />
                        <i class="delBtn iconfont u-shanchu" @click="delFaultCode(scope.row)" v-for="acc in access" v-if="acc == 'FAULTCODEDEL001'" />
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="faultCodeAdd ? '新增' : '修改'" width="500px" :visible.sync="faultCodeShow" style="text-align: left">
            <el-form :model="faultCodeDfc" :rules="fault" ref="fault" label-width="110px" class="demo-roleForm">
                <el-form-item label="所属工厂" prop="fcCode">
                    <el-select v-model="faultCodeDfc.fcCode" placeholder="请选择" :disabled="ischeck" filterable @change="selectChange">
                        <el-option v-for="factory in factoryData" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="故障编号" prop="systemCode">
                    <el-input v-model.trim="faultCodeDfc.systemCode" placeholder="请输入故障编号" :disabled="faultCodeAdd ? false : true"></el-input>
                </el-form-item>
                <el-form-item label="故障名称" prop="faultName">
                    <el-input v-model.trim="faultCodeDfc.faultName" placeholder="请输入故障名称"></el-input>
                </el-form-item>
                <el-form-item label="当前等级" prop="currentLevel">
                    <el-input-number v-model="faultCodeDfc.currentLevel" :disabled="true"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="faultCodeShow = false">取 消</el-button>
                <el-button type="primary" @click="saveFaultCode('fault')">{{ faultCodeAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data () {
    return {
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      faultCodeAdd: false,
      faultCodeShow: false,
      faultCodeList: [],
      faultCodeDfc: {
        fcCode: '',
        systemCode: '',
        faultName: '',
        currentLevel: '',
        parentId: ''
      },
      fault: {
        fcCode: [
          {
            required: true,
            message: '请选择工厂',
            trigger: 'blur'
          }
        ],
        systemCode: [
          {
            required: true,
            message: '请输入故障编号',
            trigger: 'blur'
          }
        ],
        faultName: [
          {
            required: true,
            message: '请输入故障名称',
            trigger: 'blur'
          }
        ],
        currentLevel: [
          {
            required: true,
            message: '请输入当前等级',
            trigger: 'blur'
          }
        ]
      },
      title: ['1', '2'],
      faultData: [],
      toData: [],
      faultIdList: [],
      faultId: '',
      treeNodeSelected: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      factoryData: [],
      role: [],
      ischeck: true,
      isclear: false,
      selectFcCodeShow: false,
      access: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.access = JSON.parse(sessionStorage.getItem('auths'))
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0;i < role.length;i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.faultCodeTree()
      this.getFactory()
    },
    //分页
    paginationChange (val) {
      this.searchParams.pageSize = val
      this.getAllFaultCode()
    },
    paginationCurrentChange (val) {
      this.searchParams.page = val
      this.getAllFaultCode()
    },
    updateFaultCode (row) {
      if (this.faultCodeAdd) {
        // this.faultCodeList.length == 0 ? this.faultCodeDfc.parentId = 0 : this.dfcId
        if (this.treeNodeSelected.currentLevel == 3) {
          return
        }
        this.faultCodeShow = true
        this.faultCodeDfc = {}
        if (this.ischeck && this.faultId == undefined || this.faultId == '') {
          this.faultCodeDfc.fcCode = this.userInfo.fcCode
        } else {
          this.faultId == undefined || this.faultId == '' ?
            this.faultCodeDfc.fcCode = '' : this.faultCodeDfc.fcCode = this.treeNodeSelected.fcCode
        }
        this.faultId == undefined || this.faultId == '' ?
          this.faultCodeDfc.parentId = 0 : this.faultCodeDfc.parentId = this.faultId
        this.faultId == undefined || this.faultId == '' ?
          this.faultCodeDfc.currentLevel = 1 : this.faultCodeDfc.currentLevel = parseInt(this.treeNodeSelected.currentLevel + 1)
      } else {
        this.faultCodeShow = true
        this.faultCodeDfc = JSON.parse(JSON.stringify(row))
      }
    },
    selectChange () {
      this.$forceUpdate()
    },
    saveFaultCode (fault) {
      if (this.faultCodeAdd) {
        this.$refs[fault].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              url: this.$api.addSysFaultCode,
              data: this.faultCodeDfc
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.faultCodeShow = false
                this.$message.success('新增成功！')
                this.faultCodeTree()
                this.treeNodeSelect(this.treeNodeSelected)
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs[fault].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              url: this.$api.editSysFaultCode,
              data: this.faultCodeDfc
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.faultCodeShow = false
                this.$message.success('编辑成功！')
                this.faultCodeTree()
                this.treeNodeSelect(this.treeNodeSelected)
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      }
    },
    delFaultCode (row) {
      this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'POST',
              params: {
                faultId: row.faultId
              },
              url: this.$api.deleteSysFaultCode
            })
            .then(response => {
              if (response.status == 100) {
                this.faultCodeTree()
                this.treeNodeSelect(this.treeNodeSelected)
              } else {
                this.$message.error(response.message)
              }
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.faultCodeTree()
              this.treeNodeSelect(this.treeNodeSelected)
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.faultCodeTree()
          this.treeNodeSelect(this.treeNodeSelected)
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    treeNodeSelect (nodes) {
      this.faultId = nodes.faultId
      this.treeNodeSelected = nodes
      this.getAllFaultCode()
    },
    getAllFaultCode () {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page
      }
      if (this.faultId != undefined && this.faultId != '') {
        queryParams['faultId'] = this.faultId
      }
      if (this.ischeck) {
        queryParams['fcCode'] = this.userInfo.fcCode
      }
      let options = {
        method: 'GET',
        url: this.$api.getAllSysFaultCode,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.faultCodeList = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    },
    faultCodeTree () {
      let params = {}
      if (this.ischeck) {
        params['fcCode'] = this.userInfo.fcCode
      }
      let options = {
        method: 'get',
        url: this.$api.sysFaultCodeTree,
        params: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.setFaultCode(response.data)
          this.getAllFaultCode()
        }
      })
    },
    setFaultCode (faultCode) {
      faultCode.forEach(result => {
        if (result.hasOwnProperty('faultId')) {
          if (result.child != undefined && result.child != '') {
            if (result.child[0].hasOwnProperty('faultId')) {
              this.faultIdList.push(result.faultId)
            }
          }
        }
        result.label = result.faultName
        result.value = result.faultCode
        result.children = result.child
        if (result.child != null) {
          if (result.child.length > 0) {
            this.setFaultCode(result.child)
          }
        }
      })
      this.faultData = faultCode
    },
    getFactory () {
      let options = {
        methods: 'GET',
        url: this.$api.getAllFactory
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.factoryData = []
          var aa = response.data
          if (this.ischeck) {
            var role = JSON.parse(sessionStorage.getItem('userInfo')).roles
            for (let i = 0;i < aa.length;i++) {
              for (let j = 0;j < role.length;j++) {
                if (aa[i].factoryId == role[j].factoryId) {
                  this.factoryData.push(aa[i])
                }
              }
            }
          } else {
            this.factoryData = response.data
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
